import { render, staticRenderFns } from "./TableTurnosC.vue?vue&type=template&id=96fb16f4&scoped=true"
import script from "./TableTurnosC.vue?vue&type=script&lang=js"
export * from "./TableTurnosC.vue?vue&type=script&lang=js"
import style0 from "./TableTurnosC.vue?vue&type=style&index=0&id=96fb16f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fb16f4",
  null
  
)

export default component.exports